import { Link, useLocation } from "react-router-dom";
import { LayoutGrid, Users, Calendar as CalendarIcon } from "lucide-react";

const TABS = [
  { to: "/admin/crm", label: "Tarjetas", icon: LayoutGrid, match: (p) => p === "/admin/crm" || p.startsWith("/admin/crm/tarjetas") },
  { to: "/admin/crm/clientes", label: "Clientes", icon: Users, match: (p) => p.startsWith("/admin/crm/clientes") },
  { to: "/admin/crm/calendario", label: "Calendario", icon: CalendarIcon, match: (p) => p.startsWith("/admin/crm/calendario") },
];

export default function CRMTabs() {
  const { pathname } = useLocation();
  return (
    <div className="border-b border-stone-800 bg-stone-900/50 overflow-x-auto">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 flex gap-1 min-w-max">
        {TABS.map((t) => {
          const active = t.match(pathname);
          const Icon = t.icon;
          return (
            <Link
              key={t.to}
              to={t.to}
              data-testid={`crm-tab-${t.label.toLowerCase()}`}
              className={`inline-flex items-center gap-2 px-4 py-3 text-xs uppercase tracking-[0.18em] font-bold border-b-2 transition-colors ${
                active
                  ? "text-[#E0651F] border-[#E0651F]"
                  : "text-stone-400 border-transparent hover:text-stone-200"
              }`}
            >
              <Icon className="w-4 h-4" />
              {t.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
